"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function Header({ loggedIn }: { loggedIn: boolean }) {
  const pathname = usePathname();

  return (
    <header className="hnn-header page_container">
      <div className="w-full flex items-center pl-6 py-2 gap-4">

        <Link
          href="https://www.hetnieuwenormaal.nl"
          className="flex items-center"
        >
          {/* Logo */}
          <Image
            src={"/images/hnn-logo-hor.png"}
            fill={false}
            height={48}
            width={240}
            alt="logo Het Nieuwe Normaal linkt naar homepage van www.hetnieuwenormaal.nl"
            priority
          />

        </Link>
        <menu className="hnn-header__nav ">

          {/*  <li>
               
                <Link href="/" className="no-underline group">
                <Image
                  src={"/icons/welcome.svg"}
                  width={64}
                  height={64}
                  alt="icon that links to the homepage"
                  className={`h-10 w-10 hover:bg-primary_900 ${
                  pathname === "/" && "bg-primary_900"
                  } rounded-lg`}
                />
                </Link>
                
            </li>*/}
          {loggedIn && (
            <li>
              <Link href="/dashboard/result-summary">
                <span className={`${pathname === "/dashboard/result-summary" ? "underline" : ""
                  } `}>Dashboard</span>
              </Link>
            </li>)}
          <li>
            <Link
              href="/evaluatie/create"
            >

              <span className={`${pathname === "/evaluatie/create/" ? "underline" : ""
                } `}>Evaluatie aanvraag</span>
            </Link>
          </li>
          {loggedIn && (
            <li className="list-none" >
              <Link href="/evaluatie-overzicht">

                <span className={`${pathname === "/evaluatie/create/" ? "underline" : ""
                  } `}>Mijn evaluaties</span>
              </Link>
            </li>)}

          <li>

              <Link
                href={loggedIn ? "/settings" : "/login"}
                className={`hnn-header__settings`}
              >
                <Image
                  src={"/images/Foto_user.svg"}
                  width={40}
                  height={40}
                  className="h-8 w-auto"
                  alt="icon that links to the dashboard"

                />
              </Link>
          </li>
        </menu>
      </div>
    </header>
  );
}
